module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.c8ddf1e5.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/font-awesome-4.6.3/fonts/fontawesome-webfont.woff?v=4.6.3
 ** module id = 1361
 ** module chunks = 0
 **/